import Vue from 'vue'
import {
  PopoverPlugin,
  ModalPlugin,
  TabsPlugin,
  TooltipPlugin,
  LayoutPlugin,
  ButtonPlugin,
  CarouselPlugin
} from 'bootstrap-vue'
import Vue2BingMaps from 'rhg-bing-maps'
import * as RhgVueCurrencySelector from 'rhg-vue-currency-selector'
import * as Vue2GoogleMaps from 'vue2-google-maps'
import '@/infrastructure/Filters'
import '@/infrastructure/Directives'
import App from '@/App'
import * as RhgVueCommon from 'rhg-vue-common'
import store from '@/store'
import { googleMapsApiKey, region, language } from '@/infrastructure/Configuration'

Vue.prototype.trackingService = global.trackingService
Vue.prototype.trackingEvents = global.trackingEvents

Vue.config.productionTip = false
Vue.use(PopoverPlugin)
Vue.use(LayoutPlugin)
Vue.use(ModalPlugin)
Vue.use(TooltipPlugin)
Vue.use(TabsPlugin)
Vue.use(ButtonPlugin)
Vue.use(CarouselPlugin)
Vue.use(RhgVueCommon)
Vue.use(Vue2BingMaps)
Vue.use(RhgVueCurrencySelector)
Vue.use(Vue2GoogleMaps, {
  load: {
    client: googleMapsApiKey,
    region,
    language
  }
})

window.roomDisplayVue = new Vue({
  store,
  render: h => h(App)
}).$mount('#room-display-app')
